// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2isRD","title":"AfterFrontImage_title__K7CW6"};